import { Box, Button, Dropdown, IconButton, Menu, MenuItemProps, Metadata, useGraphqlDelete, useListGraphqlQuery, useNumberFormat, useTranslation, useTranslations, useUrlParamsValueToString } from "@bsm/component";
import { TUserStudentScholarity } from "@bsm/graphql";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { SCHOLARITY_LIST_ID } from "../../../container/ScholarityListContainer";
import { useDateScholarity } from "../../../hooks/useDateScholarity";
import { DeleteScholarityDialog } from "../../../components/DeleteScholarityDialog";
import { useActivateScholarityMutation } from "../hooks/useActivateScholarityMutation";
import { ManageStudents } from "../../../components/ManageStudents";
import { useClassesItems } from "../../../../../../../hooks/useClassesItems";
import { useLevelItems } from "../../../../../../../hooks/useLevelItems";

export const ScholarityDetails = (props: Partial<TUserStudentScholarity>) => {

    const [
        EDIT,
        DELETE,
    ] = useTranslations(i18n)
    const urlParams = useUrlParamsValueToString()
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | undefined>(undefined);
    const deleteMutation = useGraphqlDelete('scholarity')
    const { invalidateQuery } = useListGraphqlQuery(SCHOLARITY_LIST_ID);
    const navigate = useNavigate()
    const dates = useDateScholarity(props)
    const t = useTranslation()
    const formatCurrency = useNumberFormat({style: "currency", currency: "GBP"});
    const activateMutation = useActivateScholarityMutation()
    const classItems = useClassesItems()
    const levelItems = useLevelItems();

    useEffect(() => {
        if (deleteMutation.isSuccess) {
            invalidateQuery()
            navigate(`..?${urlParams}`)
        }
    }, [deleteMutation])

    useEffect(() => {
        if (activateMutation.isSuccess) {
            invalidateQuery()
            navigate(`..?${urlParams}`)
        }
    }, [activateMutation])

    const [wantToDelete, setWantToDelete] = useState(false);

    const handleClick = (menu: MenuItemProps) => {
        if (menu.ke === "delete") {
            setWantToDelete(true)
        }
    }

    return (
        <div className="flex flex-col gap-4">
            {
                props.isEditable &&
                <div className="flex justify-end gap-2">
                    <Button
                        className="btn-default"
                        startIcon="fa-solid fa-pen"
                        label={EDIT}
                        onClick={() => navigate(`edit?${urlParams}`)}
                    />
                    {
                        props.isDeletable &&
                        <IconButton
                            icon={"fa-ellipsis"}
                            onClick={(e) => setAnchorEl(e.currentTarget)}
                        />
                    }

                    <Dropdown anchorEl={anchorEl} onClose={() => setAnchorEl(undefined)}>
                        <Menu
                            items={[
                                {
                                    label: DELETE,
                                    ke: 'delete'
                                }
                            ]}
                            onClick={handleClick}
                        />
                    </Dropdown>
                </div>
            }

            <Box title={"Informations"}>
                <div className="flex flex-col gap-2 mt-4">
                    
                    <Metadata
                        label={"Designation"}
                        value={props?.designation}
                    />

                    <Metadata
                        label={"Month begin"}
                        value={dates.start}
                    />

                    <Metadata
                        label={"Month end"}
                        value={dates.end}
                    />

                    <Metadata
                        label={"Level"}
                        value={levelItems[props?.scholarityClass?.level?.value]}
                    />

                    <Metadata
                        label={"Class"}
                        value={classItems[props?.scholarityClass?.class?.value]}
                    />

                    <Metadata
                        label={"Student count"}
                        value={props?.students ? props?.students?.length?.toString() : '0'}
                    />

                    <Metadata
                        label={"School fee amount"}
                        value={formatCurrency(props?.schoolFeeAmount)}
                    />

                    <Metadata
                        label={"School registration fee amount"}
                        value={formatCurrency(props?.registrationFeeAmount)}
                    />

                </div>
            </Box>
            <Box title={"Manage students"}>
                <ManageStudents {...props} />
            </Box>
            <DeleteScholarityDialog id={props?.id} open={wantToDelete} onClose={() => setWantToDelete(false)} />
        </div>
    )

}

const i18n = [
    'std_edit',
    'std_delete',
]
